export default {
  isDev: process.env.NODE_ENV === 'development',
  isProd: process.env.NODE_ENV === 'production',
  withFakeApi: process.env.WITH_FAKE_API === 'true',
  url: process.env.PUBLIC_URL,
  website: {
    url: process.env.REACT_APP_WEBSITE_URL,
  },
  api: {
    url: process.env.REACT_APP_API_ROOT_URL,
  },
  appsync: {
    url: process.env.REACT_APP_APPSYNC_ROOT_URL,
  },
  media: {
    url: process.env.REACT_APP_MEDIA_ROOT_URL,
    thumbnailUrl: `${process.env.REACT_APP_MEDIA_ROOT_URL}/${process.env.REACT_APP_MEDIA_THUMBNAIL_PATHNAME}`,
  },
  aws: {
    auth: {
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
      mandatorySignIn: false,
    },
    oauth: {
      domain: process.env.REACT_APP_IDENTITY_DOMAIN,
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN,
      redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_OUT,
      responseType: 'code',
    },
  },
};
